import { Injectable } from '@angular/core';
import { AccountService } from '../../../shared/services/account.service';
import { ReminderService } from './reminder.service';
import { MapState } from '../../map/state/map-state';
import { FeatureService } from './feature.service';
import { DatePipe } from '@angular/common';
import { forkJoin } from 'rxjs';
import { PostmanEditorService } from './postman-editor.service';
import { TranslateService } from '@ngx-translate/core';

@Injectable()
export class MapService {
  constructor(
    private accountService: AccountService,
    private reminderService: ReminderService,
    private featureService: FeatureService,
    private postmanService: PostmanEditorService,
    private translateService: TranslateService,
    private datePipe: DatePipe
  ) {
  }

  saveMapData(state: MapState) {
    let accountService = this.accountService.updateAppData({ customer_mails_sender_name: state.storeName});
    let minContentNomineeCreationDate = new Date();
    minContentNomineeCreationDate.setDate(minContentNomineeCreationDate.getUTCDate() - state.pastOrders);

    if (state.hasOrderLimitFeature && state.pastOrdersEnabled) {
      this.accountService.notifyPlatformWithPastOrders().take(1).subscribe();
    }
    let mapFeatureSettings = this.featureService.setFeatureSettings('Map', {
      settings: {
        minimum_content_nominee_creation_date: this.datePipe.transform(minContentNomineeCreationDate, 'yyyy-MM-dd')
      }
    });
    let reminderService = this.reminderService.update({ id: state.id, reminder: {
      header: state.message,
      subject: state.subject,
      enabled: state.enabled
    }});
    let toFork = [accountService, reminderService];

    if (state.hasPostmanEditorFeature && state.bodyChanged && state.message.length > 0) {
      let defaultMessage = this.translateService.instant('MAP.DEFAULT_POSTMAN_EDITOR_MESSAGE').replace(/(?:\r\n|\r|\n)/g, '<br>');
      let updatedMessage = state.message.replace(/(?:\r\n|\r|\n)/g, '<br>');

      toFork.push(this.postmanService.updateTemplateMessage(defaultMessage, updatedMessage, state.id));
    }

    if (state.hasPostmanDeliveryFeature && (state.subjectChanged || state.signatureChanged)) {
      toFork.push(this.postmanService.updateSubjectAndFromLabel(state.subject, state.storeName, +state.id));
    }

    if (mapFeatureSettings) {
      toFork.push(mapFeatureSettings);
    }

    return forkJoin(
      ...toFork
    );
  }
}
